import React, { useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { defaultLogoCdnUrl } from '../../config/environments';

const LOGO_LOCAL = `${process.env.PUBLIC_URL || ''}/candorlogo.png`;
const LOGO_CDN = defaultLogoCdnUrl();

/**
 * Candor logo image with local → CDN → letter fallback.
 * @param {{ size?: number; alt?: string }} props
 */
const CandorLogoMark = ({ size = 40, alt = 'Candor' }) => {
  const [src, setSrc] = useState(LOGO_LOCAL);
  const [showFallback, setShowFallback] = useState(false);

  const handleError = useCallback(() => {
    if (src === LOGO_LOCAL) {
      setSrc(LOGO_CDN);
      return;
    }
    setShowFallback(true);
  }, [src]);

  if (showFallback) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: 2,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: 700,
          fontSize: size * 0.38,
          letterSpacing: '-0.02em',
          background: 'linear-gradient(145deg, #1d4ed8 0%, #0d9488 100%)',
          boxShadow: '0 2px 10px rgba(37, 99, 235, 0.28)',
        }}
        aria-hidden
      >
        C
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      onError={handleError}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
};

export default CandorLogoMark;
export { LOGO_LOCAL, LOGO_CDN };
